import { render, staticRenderFns } from "./SearchPopupView.vue?vue&type=template&id=5a9bc9f9&scoped=true&"
import script from "./SearchPopupView.vue?vue&type=script&lang=js&"
export * from "./SearchPopupView.vue?vue&type=script&lang=js&"
import style0 from "./SearchPopupView.vue?vue&type=style&index=0&id=5a9bc9f9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9bc9f9",
  null
  
)

export default component.exports